import './FAQsPage.scss';
import Navbar from '../../components/CommonComponents/Navbar/Navbar'
import { Typography, Select, MenuItem, FormControl } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { FAQList } from '../../assets/configs/FAQsPage/faqsJson';
import AddSpace from '../../components/UtilityComponents/AddSpace/AddSpace';
import FAQsSection from '../../components/CommonComponents/FAQsSection/FAQsSection';
import Footer from '../../components/CommonComponents/Footer/Footer';
import logAnalyticsEvent from '../../services/AnalyticsManager/AnalyticsManager';
import { GGAnalyticsEvents } from '../../services/AnalyticsManager/GGAnalyticsEvents';

const FAQsPage = () => {

    const FAQJsonToArray = Object.keys(FAQList);
    const [selectedFAQSection, setSelectedFAQSection] = useState(0);

    useEffect(() => {
        document.title = "GenieGig | FAQs";
        window.scrollTo(0,0)
        logAnalyticsEvent(GGAnalyticsEvents.FAQS_PAGE_LOADED);
      },[])

    return (
        <div className='FAQs-page'>
            <AddSpace vSpace={"10vh"} hSpace={"0"} />
            <Navbar useScrollVersion={true} />

            <div className="main-container">
                <div className="header">
                    <div className="title">
                        <Typography fontSize={32} fontWeight={700}>
                            FAQs
                        </Typography>
                    </div>
                </div>

                <div className="faqs-section">
                    {/* Mobile Dropdown Selector */}
                    <div className="mobile-faq-selector">
                        <FormControl fullWidth>
                            <Select
                                value={selectedFAQSection}
                                onChange={(e) => setSelectedFAQSection(Number(e.target.value))}
                                displayEmpty
                                className="faq-dropdown"
                            >
                                {FAQJsonToArray.map((key, index) => (
                                    <MenuItem key={index} value={index}>
                                        {FAQList[FAQJsonToArray[index]].categoryTitle}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>

                    {/* Desktop FAQ Section List */}
                    <div className="faq-section-list">
                    {
                        FAQJsonToArray.map((key, index) => (
                            <React.Fragment key={index}>
                            
                            <Typography
                                className={index === selectedFAQSection ? "faq-section-list-item selected" :  "faq-section-list-item"}
                                onClick={() => setSelectedFAQSection(index)}
                            >
                                {FAQList[FAQJsonToArray[index]].categoryTitle}
                            </Typography>

                            {index !== FAQJsonToArray.length - 1 && <div className="separator"></div>}
                            </React.Fragment>
                        ))
                    }

                    </div>
                    <div className="faq-section-details">
                        <Typography className="faq-section-title" fontSize={20} fontWeight={500}>
                            {FAQList[FAQJsonToArray[selectedFAQSection]].categoryTitle}
                        </Typography>
                        <FAQsSection faqSection={FAQList[FAQJsonToArray[selectedFAQSection]]} questionFocusBackgroundColor='#F3F3F3' questionNonFocusBackgroundColor='#F3F3F3'/>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default FAQsPage